//CSS
import "../../Components/Page/Page.css";
import "./NewGeometries.css";
import slide3 from "../../Images/Slides/90aSlide3.png";
import SlideComp from "../../Components/SlideComp/SlideComp";

//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";

const NewGeometries: React.FC = () => {
  return (
    <div id="Goals">
      <SecHeader title={"Intro"} />
      <SlideComp source={slide3} />
    </div>
  );
};

export default NewGeometries;
